var classList = require('dom-classlist');
var gsap = require('gsap');
var pubsub = require('pubsub');
var serialize = require('form-serialize');
var xhr = require('xhr');
var ScrollTo = require('partials/scroll-to');


module.exports = function (el, blocT) {
	var _form = el
	,	_inputs = _form.querySelectorAll('input[type="text"], input[type="email"], input[type="radio"], input[type="file"], textarea, select')
	,	_todoInput = _form.querySelector('input[name=todo]')

	,	_statusField = _form.querySelector('#status')
	,	_statusFieldMore = _form.querySelector('#status_other')
	,	_studentFieldMore = _form.querySelector('#status_student')

	,	_iframe = blocT.querySelector('iframe')

	,	_confirmField = _form.querySelector('.confirm')

	,	_submitWrapper = _form.querySelector('.wrapper.submit')
	,	_submitInput = _form.querySelector('.wrapper.submit input[type=submit]')
	// ,	_btStep = _form.querySelector('.bt.step')
	,	_btSubmit = _form.querySelector('.bt.send')

	,	_btFile = _form.querySelector('input[type="file"]')
	,	_btTrigger = blocT.querySelector('.triggerAnim')
	,	_btPrev = blocT.querySelector('.bt.prev')
	,	method = _form.method
	,	action = _form.action
	,	to
	,	isLoading = false;



	// --------------------------------------------------------------------------------------------
	// HANDLERS
	addHandlers()
	function addHandlers() {

		// SUBMIT FORM
		_form.addEventListener('submit', submitProject);

		_statusField.addEventListener('change', showOtherStatus);

		_btFile.addEventListener('change', createNewFileEntry);

		_btPrev.addEventListener('click', prevStep)


		Array.prototype.forEach.call(blocT.querySelectorAll('.slide-2, .slide-3'), function(slide){
			TweenMax.set(slide,{autoAlpha : 0});
		})
	}


	/**
	 * Show/Hide text input
	 */
	function showOtherStatus()
	{
		switch (this.value) {
			case 'other':
				classList(_statusFieldMore).remove('hide');
				classList(_studentFieldMore).add('hide');
				break;

			case 'student':
				classList(_statusFieldMore).add('hide');
				classList(_studentFieldMore).remove('hide');
				break;
		
			default:
				classList(_statusFieldMore).add('hide');
				classList(_studentFieldMore).add('hide');
				break;
		}

	}


	/**
	 *
	 */
	function createNewFileEntry(e)
	{
		classList(e.target.parentNode).remove('error');
		var fileName = e.target.value.split(/(\\|\/)/g).pop();
		var wrapper = e.target.parentNode.parentNode.parentNode;
		wrapper.querySelector('.filePath').style.lineHeight = '25px';
		wrapper.querySelector('.filePath').innerHTML = '<b>'+wrapper.querySelector('.filePath').getAttribute('data-text-delete')+'</b><br/>'+fileName;
		wrapper.querySelector('input[type="file"]').style.display ="none";
		wrapper.querySelector('.add').style.display ="none";
		wrapper.querySelector('.delete').style.display ="block";

		var _btRemove = wrapper.querySelector('.delete');
		_btRemove.addEventListener('click', removeFile);
	}


	/**
	 *
	 */
	function removeFile(e)
	{
		var wrapper = e.target.parentNode.parentNode.parentNode;
		classList(wrapper).remove('error');
		wrapper.querySelector('.filePath').innerHTML = wrapper.querySelector('.filePath').getAttribute('data-text-add');
		wrapper.querySelector('input[type="file"]').value= '';
		wrapper.querySelector('input[type="file"]').style.display ="block";
		wrapper.querySelector('.add').style.display ="block";
		wrapper.querySelector('.delete').style.display ="none";
	}


	/**
	 *
	 */
	function beforeSend()
	{
		if(isLoading) return;
		isLoading = true;


		classList(_confirmField).remove('active')
		Array.prototype.forEach.call(_inputs, function(input){
			classList(input).remove('error')
		})
	}


	/**
	 * for dossier depot
	 */
	function submitProject(e)
	{

		beforeSend();
		classList(_submitInput).add('hide');

		_iframe.onload = function(e) {

			var response = this.contentWindow.document.body.innerHTML;

			// MANAGE RESPONSE AFTER 500ms
			setTimeout(function() {

				// PARSE JSON
				var JSONbody = JSON.parse(response);
				Array.prototype.forEach.call(JSONbody, function(el, i) {

					// MANAGE ERRORS
					if(el.level == 'error') {
						switch(el.field) {
							default:
								classList(_form.querySelector('input[name='+el.field+']')).add('error');
							break;
							case 'status':
								classList(_form.querySelector('select[name='+el.field+']')).add('error');
							break;
							case 'msg':
								classList(_form.querySelector('textarea[name='+el.field+']')).add('error');
							break;
							case 'studies':
								//classList(_form.querySelector('#'+el.field+'-yes')).add('error')
								//classList(_form.querySelector('#'+el.field+'-no')).add('error')
							break;
							case 'file1':
								classList(_form.querySelector('input[name='+el.field+']').parentNode.parentNode.parentNode).add('error');
								
							break;
						}
					}
					// MANAGE SUCCESS
					if(el.level == 'success') {
						switch(el.field) {

							case 'slide2':
								nextStep();
							break;
							case 'closeT1':
								//scroll top to see sucess msg
								ScrollTo(blocT, 1) 

								// anim to show success msg in slide 3
								TweenMax.to(blocT.querySelector('.slide-2'),.6,{x : '-135%',ease: Power3.easeInOut,autoAlpha : 0});
								TweenMax.to(blocT.querySelector('.slide-3'),.6,{x : '-200%',ease: Power3.easeInOut,autoAlpha : 1});

								TweenMax.to(blocT.querySelector('.project'),.4,{autoAlpha : 0, height : 0,ease: Power3.easeInOut});

								
								_form.reset();
							break;
						}
					}
				});
				classList(_submitInput).remove('hide');
				isLoading = false;
			}, 500);
		};
	}  


	/**
	 *
	 */
	function nextStep()
	{

		_todoInput.value = 'projet';
		_submitInput.value = _submitInput.getAttribute('data-text-step2');
		classList(_form.querySelector('.slide-2')).remove('hide');

		Array.prototype.forEach.call(blocT.querySelectorAll('.slide-1'), function(slide){
			TweenMax.to(slide,.5,{x : '-35%',ease: Power3.easeInOut,autoAlpha : 0});
		})
		Array.prototype.forEach.call(blocT.querySelectorAll('.slide-2'), function(slide){
			TweenMax.to(slide,.6,{x : '-100%',ease: Power3.easeInOut,autoAlpha : 1});
		})
	}


	/** 
	 *
	 */
	function prevStep()
	{

		_todoInput.value = 'check-step-1';
		_submitInput.value = _submitInput.getAttribute('data-text-step1');
		classList(_form.querySelector('.slide-2')).add('hide');

		Array.prototype.forEach.call(blocT.querySelectorAll('.slide-1'), function(slide){
			TweenMax.to(slide,.5,{x : '0%',ease: Power3.easeInOut,autoAlpha : 1});
		})
		Array.prototype.forEach.call(blocT.querySelectorAll('.slide-2'), function(slide){
			TweenMax.to(slide,.6,{x : '0%',ease: Power3.easeInOut,autoAlpha : 0});
		})
	}


	/**
	 * Send newsletter form
	 */
	function clickSubmit(e) {
		e.preventDefault();
		submitForm();
	}
}
